// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import xOrderInformationStyles from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqConfirmationDetailsStyles } from "@steiner/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const gridItemValue: GridItemProps = {
    width: [12, 6, 6, 4, 4],
    css: css`
        ${xScreen("lt", "sm")} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

rfqConfirmationDetailsStyles.openBidsLinkText = {
    mergeCss: true,
    typographyProps: {
        size: 14,
        variant: "h6",
        weight: fontConfig.weight.semiBold,
        css: css`
            margin-bottom: 0;
            &:empty:after {
                content: "- -";
            }
            @media print {
                display: inline-block;
                width: auto;
            }
        `,
    },
};
rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 0,
};

rfqConfirmationDetailsStyles.jobNameGridItem =
    rfqConfirmationDetailsStyles.salesRepGridItem =
    rfqConfirmationDetailsStyles.statusGridItem =
    rfqConfirmationDetailsStyles.customerGridItem =
    rfqConfirmationDetailsStyles.shipToGridItem =
    rfqConfirmationDetailsStyles.notesGridItem =
        {
            ...gridItemValue,
        };

rfqConfirmationDetailsStyles.dateGridItem = {
    ...mergeWithCss(
        gridItemValue,
        css`
            align-items: baseline;
        `,
    ),
};

rfqConfirmationDetailsStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.labelWithDots, {
        css: css`
            margin-bottom: 4px;
        `,
    }),
};

rfqConfirmationDetailsStyles.customerHeadingAndText =
    rfqConfirmationDetailsStyles.shipToHeadingAndText =
    rfqConfirmationDetailsStyles.notesHeadingAndText =
    rfqConfirmationDetailsStyles.statusHeadingAndText =
    rfqConfirmationDetailsStyles.salesRepHeadingAndText =
    rfqConfirmationDetailsStyles.jobNameHeadingAndText =
        {
            ...xOrderInformationStyles.headingAndTextStyles,
        };

rfqConfirmationDetailsStyles.temporaryBidNumberHeadingAndText = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles, {
        wrapper: {
            css: css`
                margin-bottom: 12px;
            `,
        },
        heading: {
            weight: fontConfig.weight.bold,
            size: 16,
        },
    }),
};
rfqConfirmationDetailsStyles.submittedDateValue = {
    forwardAs: "span",
    size: 14,
};

rfqConfirmationDetailsStyles.tempBidNumberGridItem = { width: [6, 6, 4, 4, 4] };
